import { Rest } from "utilities/rest";
import * as ActionCreator from "utilities/action.creator";
import { $failure, $requesting, $success } from "../form/action";
import { $processing } from "services/activity/action";
import { $done } from "services/activity/action";

export const MODULE = "Job";

const API_URL = `${process.env.REACT_APP_SERVICE_SYSTEM_URL}`;

export const $reset = ActionCreator.Default(MODULE, "reset", () =>
  $reset.action()
);

export const $show = ActionCreator.Async(MODULE, "Show", (id) => {
  return async (dispatch) => {
    dispatch($processing($show.OPERATION));

    return await Rest.GET(`${API_URL}/tms/job/${id}`)
      .then((response) => {
        dispatch($show.success({ response: response?.data }));
        return response;
      })
      .catch((error) => {
        return false;
      })
      .finally(() => dispatch($done($show.OPERATION)));
  };
});

export const $getJobByManifest = ActionCreator.Async(
  MODULE,
  "Get.Manifest",
  (id) => {
    return async (dispatch) => {
      dispatch($processing($getJobByManifest.OPERATION));

      return await Rest.GET(`${API_URL}/tms/job/manifest/${id}`)
        .then((response) => {
          return response;
        })
        .catch((error) => {
          return false;
        })
        .finally(() => dispatch($done($getJobByManifest.OPERATION)));
    };
  }
);

export const $pickup = ActionCreator.Async(MODULE, "Pickup", (id, payload) => {
  return async (dispatch) => {
    dispatch($requesting.action());

    return await Rest.PUT(`${API_URL}/tms/job/${id}/pickup`, payload)
      .then((response) => {
        dispatch($pickup.success({ response: response?.data }));
        dispatch($success.action());
        return response;
      })
      .catch((error) => {
        dispatch($failure({ error }));
        return false;
      });
  };
});
